import React from 'react';

export default function SvgDownCaret() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none">
      <g>
        <path stroke="#000" d="m16.12 8-5.834 5.833L4.453 8" />
      </g>
    </svg>
  );
}
